import http from '@/plugins/http'

export * from './constants'
export * from './lib'

export const getUserInfoApi = async (uid, skey) => {
  // const apiUrl = `https://user.cekid.com/user/GetUserInfo?uid=${uid}&skey=${skey}`
  return http.get('https://user.cekid.com/user/GetUserInfo', { uid, skey })
}
